const HQ_TOKEN_KEY = "hq_access_token";

export function getHqToken(): string | null {
  return localStorage.getItem(HQ_TOKEN_KEY);
}

export function setHqToken(token: string) {
  localStorage.setItem(HQ_TOKEN_KEY, token);
}

export function clearHqToken() {
  localStorage.removeItem(HQ_TOKEN_KEY);
}

export function isHqAuthenticated(): boolean {
  return Boolean(getHqToken());
}
